import { FunctionComponent, PropsWithChildren } from 'react'
import { Box } from '@mui/material'
import { HEADER_HEIGHT, Header } from 'components/Header'
import { Sidebar } from 'components/Sidebar'
import withEmailCheck from './WithEmailCheck'

interface Props extends PropsWithChildren {}

const PageWrapper: FunctionComponent<Props> = ({ children }) => {
  return (
    <>
      <Header />
      <Box display="flex">
        <Sidebar />
        <Box
          p={2}
          flexGrow="1"
          bgcolor="#F4F4F9"
          sx={{
            overflowX: 'scroll',
            height: `calc(100vh - ${HEADER_HEIGHT}px)`,
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  )
}

export default withEmailCheck(PageWrapper)
